import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    className: 'devtools',

    feedback_id: '',

    show_event: true,

    is_console_logs_loaded: false,
    is_network_logs_loaded: false,
    is_event_logs_loaded: false,

    console_logs: [],
    console_type: [],

    network_type: [],
    network_status: [],
    network_logs: [],

    event_logs: [],

    events: {
        'click .devtool-tab > div'       : 'selectTab',
        'click .json-expand'             : 'expandJson',
        'click .console-filter-type li'  : 'onConsoleTypeChange',
        'click .network-filter-type li'  : 'onNetworkTypeChange',
        'click .network-filter-status li': 'onNetworkStatusChange',
    },

    dom_handlers: {
        selectTab: function(e) {
            var tab = $(e.currentTarget).data('type');

            this.$el.find('.devtool-tab > div').removeClass('active');
            $(e.currentTarget).addClass('active');

            this.$el.find('.devtool-content').removeClass('active');
            this.$el.find('.devtool-content[data-type="' + tab + '"]').addClass('active');
        },

        expandJson: function(e) {
            $(e.currentTarget).parents('.log-item:first').toggleClass('expanded');
        },

        onConsoleTypeChange: function(e) {
            var value = $(e.currentTarget).data('value');
            var is_all = value === '';
            var index = this.console_type.indexOf(value);

            if (is_all) {
                this.$el.find('.console-filter-type li').removeClass('selected');
                $(e.currentTarget).addClass('selected');
                this.console_type = [];
            } else {
                $(e.currentTarget).toggleClass('selected');

                if (index === -1) {
                    this.console_type.push(value);
                } else {
                    this.console_type.splice(index, 1);
                }

                if (this.console_type.length) {
                    this.$el.find('.console-filter-type li[data-value=""]').removeClass('selected');
                } else {
                    this.$el.find('.console-filter-type li[data-value=""]').addClass('selected');
                }
            }

            this.renderConsoleLogs();
        },

        onNetworkTypeChange: function(e) {
            var value = $(e.currentTarget).data('value');
            var is_all = value === '';
            var index = this.network_type.indexOf(value);

            if (is_all) {
                this.$el.find('.network-filter-type li').removeClass('selected');
                $(e.currentTarget).addClass('selected');
                this.network_type = [];
            } else {
                $(e.currentTarget).toggleClass('selected');

                if (index === -1) {
                    this.network_type.push(value);
                } else {
                    this.network_type.splice(index, 1);
                }

                if (this.network_type.length) {
                    this.$el.find('.network-filter-type li[data-value=""]').removeClass('selected');
                } else {
                    this.$el.find('.network-filter-type li[data-value=""]').addClass('selected');
                }
            }

            this.renderNetworkLogs();
        },

        onNetworkStatusChange: function(e) {
            var value = $(e.currentTarget).data('value');
            var is_all = value === '';
            var index = this.network_status.indexOf(value);

            if (is_all) {
                this.$el.find('.network-filter-status li').removeClass('selected');
                $(e.currentTarget).addClass('selected');
                this.network_status = [];
            } else {
                $(e.currentTarget).toggleClass('selected');

                if (index === -1) {
                    this.network_status.push(value);
                } else {
                    this.network_status.splice(index, 1);
                }

                if (this.network_status.length) {
                    this.$el.find('.network-filter-status li[data-value=""]').removeClass('selected');
                } else {
                    this.$el.find('.network-filter-status li[data-value=""]').addClass('selected');
                }
            }

            this.renderNetworkLogs();
        },
    },

    event_handlers: {
        onConsoleLogLoad: function(e) {
            this.console_logs = Cache.feedback_console_log.where({feedback_id: this.feedback_id}).map((model) => {
                return model.toJSON();
            });
            this.is_console_logs_loaded = true;

            this.renderConsoleLogs();
        },

        onNetworkLogLoad: function(e) {
            this.network_logs = Cache.feedback_network_log.where({feedback_id: this.feedback_id}).map((model) => {
                return model.toJSON();
            });
            this.is_network_logs_loaded = true;

            this.renderNetworkLogs();
        },

        onEventLogLoad: function(e) {
            this.event_logs = Cache.feedback_event_track.where({feedback_id: this.feedback_id}).map((model) => {
                return model.toJSON();
            });
            this.is_event_logs_loaded = true;

            this.renderEvents();
        },
    },

    isSame: function(data_a, data_b) {
        if (data_a.type === data_b.type && JSON.stringify(data_a.data) ===  JSON.stringify(data_b.data)) {
            return true;
        }

        return false;
    },

    formatBytes: function(bytes) {
        if (bytes === 0) return '-';

        const units = ['B', 'KB', 'MB', 'GB'];
        const base = 1024;
        const index = Math.floor(Math.log(bytes) / Math.log(base));
        const size = (bytes / Math.pow(base, index)).toFixed(2);

        return `${size} ${units[index]}`;
    },

    formatNetworkTime: function(timeMs) {
        if (timeMs < 1) {
            return `${timeMs.toFixed(2)} ms`;
        } else if (timeMs < 1000) {
            return `${timeMs.toFixed(2)} ms`;
        } else if (timeMs < 60000) {
            return `${(timeMs / 1000).toFixed(2)} s`;
        } else {
            const total_seconds = Math.floor(timeMs / 1000);
            const minutes = Math.floor(total_seconds / 60);
            const seconds = total_seconds % 60;
            return `${minutes}m ${seconds}s`;
        }
    },

    initialize: function(options) {
        this.show_event = options.show_event;
        this.feedback_id = options.feedback_id;
        this.open_by_default = options.open_by_default;
        this.is_console_logs_loaded = options.is_console_logs_loaded;
        this.is_network_logs_loaded = options.is_network_logs_loaded;
        this.is_event_logs_loaded = options.is_event_logs_loaded;

        this.console_logs = [];
        this.network_logs = [];
        this.event_logs = [];

        this.console_type = [];
        this.network_type = [];
        this.network_status = [];

        if (!Cache.account.hasFeature('browser_events')) {
            this.show_event = false;
        }

        this.loadData();
    },

    loadData: function() {
        if (!this.feedback_id) {
            return;
        }

        const loaded = this.is_console_logs_loaded && this.is_network_logs_loaded && this.is_event_logs_loaded;

        if (Cache.app.devtools_data_loaded_feedback_id === this.feedback_id || loaded) {
            this.onLoad();
            return;
        }

        Cache.app.request({
            action: 'feedback/getTrackingData',
            data: {
                feedback_id: this.feedback_id
            },
            success: (response) => {
                Cache.feedback_console_log.reset(response.feedback_console_log);
                Cache.feedback_event_track.reset(response.feedback_event_track);
                Cache.feedback_network_log.reset(response.feedback_network_log);

                Cache.app.devtools_data_loaded_feedback_id = this.feedback_id;

                this.onLoad();
            },
        });
    },

    onLoad: function () {
        this.console_logs = Cache.feedback_console_log.where({feedback_id: this.feedback_id}).map((model) => {
            return model.toJSON();
        });
        this.network_logs = Cache.feedback_network_log.where({feedback_id: this.feedback_id}).map((model) => {
            return model.toJSON();
        });
        this.event_logs = Cache.feedback_event_track.where({feedback_id: this.feedback_id}).map((model) => {
            return model.toJSON();
        });

        this.is_console_logs_loaded = true;
        this.is_network_logs_loaded = true;
        this.is_event_logs_loaded = true;

        this.renderConsoleLogs();
        this.renderEvents();
        this.renderNetworkLogs();
    },

    updateConsoleLogs: function(data) {
        this.console_logs = data;
        this.is_console_logs_loaded = true;

        this.renderConsoleLogs();
    },

    renderConsoleLogs: function() {
        var content_html = '';

        var console_logs = [];

        this.console_logs.filter((data) => {
            if (this.console_type.length) {
                return this.console_type.includes(data.type);
            }

            return true;
        }).forEach((data) => {
            if (console_logs.length && this.isSame(data, console_logs[console_logs.length - 1].data)) {
                console_logs[console_logs.length - 1].counter++;
            } else {
                console_logs.push({
                    data: data,
                    counter: 1
                });
            }
        });

        console_logs.forEach((log_item) => {
            var items = log_item.data.data;

            content_html += '<div data-type="' + log_item.data.type + '" data-count="' + log_item.counter + '">';

            if (log_item.counter > 1) {
                content_html += '<span class="log-counter">' + log_item.counter + '</span>';
            }

            _.each(items, (item) => {
                var is_number_string = item.type === 'string' && Util.isNumeric(item.val);
                var type = is_number_string ? 'number_string' : item.type;

                content_html +=
                '<div class="log-item" data-type="' + type + '">' +
                    (type === 'json' ? '<span class="json-expand"><i class="fas fa-caret-right"></i></span>' : '') +
                    (is_number_string ? '"' : '') +
                    (type === 'json' ? Util.jsonHighlight(item.val) : Util.htmlEntities(item.val)) +
                    (is_number_string ? '"' : '') +
                    (log_item.data.goto? '<div class="goto" data-goto="' + log_item.data.goto + '">Goto <i class="fas fa-share"></i></div>' : '') +
                '</div>';
            });

            content_html += '</div>';
        });

        if (this.is_console_logs_loaded) {
            this.$el.find('.devtool-content[data-type="console_log"] .console-loading').hide();

            if (console_logs.length) {
                this.$el.find('.devtool-content[data-type="console_log"] .console-empty').hide();
            } else {
                this.$el.find('.devtool-content[data-type="console_log"] .console-empty').css('display', 'block');
            }
        }

        if (console_logs.length) {
            this.$el.find('.devtool-content[data-type="console_log"] .console-logs').html(content_html);
            this.$el.find('.console-item-count').show().html(console_logs.length);
            this.$el.find('.devtool-content[data-type="console_log"] .console-loading').hide();
        }

        this.$el.find('.console-searchbar').toggle(!!this.console_logs.length);
    },

    updateNetworkLogs: function(data) {
        this.network_logs = data;
        this.is_network_logs_loaded = true;

        this.renderNetworkLogs();
    },

    renderNetworkLogs: function() {
        var content = '';

        this.network_logs.forEach((item) => {
            if (this.network_keyword) {
                var index = item.name.indexOf(this.network_keyword);

                if (index === -1) {
                    return;
                }
            }

            if (this.network_type.length) {
                var matched = this.network_type.some((type) => {
                    if (type === 'other') {
                        return ['css', 'fetch', 'iframe', 'img', 'link', 'script', 'xmlhttprequest'].indexOf(item.initiatorType) === -1;
                    }

                    return item.initiatorType === type;
                });

                if (!matched) {
                    return;
                }
            }

            if (this.network_status.length) {
                var matched = this.network_status.some((status) => {
                    switch (status) {
                        case '1xx':
                            return item.responseStatus >= 100 && item.responseStatus < 200;
                        case '2xx':
                            return item.responseStatus >= 200 && item.responseStatus < 300;
                        case '3xx':
                            return item.responseStatus >= 300 && item.responseStatus < 400;
                        case '4xx':
                            return item.responseStatus >= 400 && item.responseStatus < 500;
                        case '5xx':
                            return item.responseStatus >= 500;
                        case 'unknown':
                            return !item.responseStatus;
                    }
                });

                if (!matched) {
                    return;
                }
            }

            var status_dot = '';

            if (item.responseStatus === 0) {
                status_dot = '<span class="grey-dot"></span>';
            } else if (item.responseStatus >= 400) {
                status_dot = '<span class="error-dot"></span>';
            } else {
                status_dot = '<span class="success-dot"></span>';
            }

            content +=
                '<tr class="' + (item.responseStatus >= 400 ? 'error' : '') + '">' +
                    '<td>' + status_dot + (item.responseStatus === 0 ? 'Unknown' : item.responseStatus) + '</td>' +
                    '<td>' + (item.initiatorType || '') + '</td>' +
                    '<td title="' + item.name + '">' + item.name + '</td>' +
                    '<td' + (item.encodedBodySize ? ' class="tooltip" data-title="' + this.formatBytes(item.encodedBodySize) + ' transferred over network, resource size ' + this.formatBytes(item.decodedBodySize) + '"' : '') + '>' + this.formatBytes(item.encodedBodySize) + (item.encodedBodySize ? '</td>' : '') +
                    '<td>' + this.formatNetworkTime(item.duration) + '</td>' +
                    '<td>' + (item.nextHopProtocol || '-') + '</td>' +
                '</tr>';
        });

        this.$el.find('.network-table tbody').html(content);

        if (this.is_network_logs_loaded) {
            this.$el.find('.network-loading').hide();

            if (content) {
                this.$el.find('.network-empty').hide();
            } else {
                this.$el.find('.network-empty').css('display', 'block');
            }
        }

        if (content) {
            this.$el.find('.network-table').removeClass('empty');
            this.$el.find('.network-table table').show();
        } else {
            this.$el.find('.network-table').addClass('empty');
            this.$el.find('.network-table table').hide();
        }

        if (this.network_logs.length) {
            this.$el.find('.network-item-count').show().html(this.network_logs.length);
            this.$el.find('.network-loading').hide();
        }

        this.$el.find('.network-searchbar').toggle(!!this.network_logs.length);
    },

    updateEventLogs: function(data) {
        this.event_logs = data;
        this.is_event_logs_loaded = true;

        this.renderEvents();
    },

    renderEvents: function() {
        if (!this.show_event) {
            return;
        }

        var content = '';

        this.event_logs.forEach(function(item) {
            content +=
            '<div data-type="event_' + item.type + '" data-count="1">' +
                '<span class="event-type">ui.click</span>' +
                '<span class="log-item" data-type="event">' + item.log_value + '</span>' +
            '</div>';
        });

        if (this.is_event_logs_loaded) {
            this.$el.find('.devtool-content[data-type="event_track"] .event-loading').hide();

            if (this.event_logs.length) {
                this.$el.find('.devtool-content[data-type="event_track"] .event-empty').hide();
            } else {
                this.$el.find('.devtool-content[data-type="event_track"] .event-empty').css('display', 'block');
            }
        }

        if (this.event_logs.length) {
            content += '<div class="log-item" data-type="info" data-count="1">Feedback submitted</div>';

            this.$el.find('.devtool-content[data-type="event_track"] .event-logs').html(content);
            this.$el.find('.devtool-content[data-type="event_track"] .event-loading').hide();
            this.$el.find('.event-item-count').show().html(this.event_logs.length + 1);
        }
    },

    render: function() {
        var content =
            '<div class="region-devtools-body' + (this.open_by_default ? ' open' : '') + '">' +
                '<div class="devtool-tab">' +
                    '<div data-type="console_log" class="active"><i class="fas fa-terminal"></i>Console Logs' +
                        '<span class="console-item-count badge-secondary-invert badge-round badge-small badge-fluid" style="display: none"></span>' +
                    '</div>' +
                    '<div data-type="network_log"><i class="far fa-globe"></i>Network Requests' +
                        '<span class="network-item-count badge-secondary-invert badge-round badge-small badge-fluid" style="display: none"></span>' +
                    '</div>' +
                    (this.show_event ? '<div data-type="event_track"><i class="far fa-bullseye-pointer"></i>Events' +
                        '<span class="event-item-count badge-secondary-invert badge-round badge-small badge-fluid" style="display: none"></span>' +
                    '</div>': '') +
                '</div>' +
                '<div class="devtool-content active" data-type="console_log">' +
                    '<div class="console-searchbar">' +
                        '<div class="console-filter-type button-dropdown" data-autoclose="false" data-append="true" data-flip="true">' +
                            '<button type="button" class="dropdown-select dropdown-select-small">Type</button>' +
                            '<div>' +
                                '<ul class="dropdown dropdown-select">' +
                                    '<li class="selected" data-value="">All</li>' +
                                    '<li class="separator"></li>' +
                                    '<li data-value="log">Log</li>' +
                                    '<li data-value="error">Error</li>' +
                                    '<li data-value="warn">Warn</li>' +
                                    '<li data-value="info">Info</li>' +
                                    '<li data-value="debug">Debug</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="console-content">' +
                        '<div class="console-empty" data-type="info" data-count="1">No console logs recorded. <a href="https://support.userback.io/en/articles/5209170-developer-tools-console-log-network-requests-and-event-tracking" class="primary font-weight-medium" target="help" rel="noopener">Find out more <i class="fa-solid fa-square-arrow-up-right"></i></a></div>' +
                        '<div class="console-loading">Loading...</div>' +
                        '<div class="console-logs"></div>' +
                    '</div>' +
                '</div>' +
                '<div class="devtool-content" data-type="network_log">' +
                    '<div class="network-searchbar">' +
                        '<div class="network-filter-status button-dropdown" data-flip="true" data-append="true" data-autoclose="false">' +
                            '<button type="button" class="dropdown-select dropdown-select-small">Status</button>' +
                            '<div>' +
                                '<ul class="dropdown dropdown-select">' +
                                    '<li class="selected" data-value="">All</li>' +
                                    '<li class="separator"></li>' +
                                    '<li data-value="1xx">1XX</li>' +
                                    '<li data-value="2xx">2XX</li>' +
                                    '<li data-value="3xx">3XX</li>' +
                                    '<li data-value="4xx">4XX</li>' +
                                    '<li data-value="5xx">5XX</li>' +
                                    '<li data-value="unknown">Unknown</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                        '<div class="network-filter-type button-dropdown" data-flip="true" data-append="true" data-autoclose="false">' +
                            '<button type="button" class="dropdown-select dropdown-select-small">Type</button>' +
                            '<div>' +
                                '<ul class="dropdown dropdown-select">' +
                                    '<li class="selected" data-value="">All</li>' +
                                    '<li class="separator"></li>' +
                                    '<li data-value="css">CSS</li>' +
                                    '<li data-value="fetch">Fetch</li>' +
                                    '<li data-value="iframe">iFrame</li>' +
                                    '<li data-value="img">Img</li>' +
                                    '<li data-value="link">Link</li>' +
                                    '<li data-value="script">Scritp</li>' +
                                    '<li data-value="xmlhttprequest">XHR</li>' +
                                    '<li data-value="other">Other</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="network-table">' +
                        '<table class="sticky-header">' +
                            '<thead>' +
                                '<tr>' +
                                    '<th name="status">Status</th>' +
                                    '<th name="type">Type</th>' +
                                    '<th name="name">Name</th>' +
                                    '<th name="size">Size</th>' +
                                    '<th name="time">Time</th>' +
                                    '<th name="protocol">Protocol</th>' +
                                '</tr>' +
                            '</thead>' +
                            '<tbody></tbody>' +
                        '</table>' +
                        '<div class="network-empty">No network requests captured. <a href="https://support.userback.io/en/articles/5209170-developer-tools-console-log-network-requests-and-event-tracking" class="primary font-weight-medium" target="help" rel="noopener">Find out more <i class="fa-solid fa-square-arrow-up-right"></i></a></div>' +
                        '<div class="network-loading">Loading...</div>' +
                    '</div>' +
                 '</div>' +
                '<div class="devtool-content" data-type="event_track">' +
                    '<div class="event-empty" data-type="info" data-count="1">No events tracked. <a href="https://support.userback.io/en/articles/5209170-developer-tools-console-log-network-requests-and-event-tracking" class="primary font-weight-medium" target="help" rel="noopener">Find out more <i class="fa-solid fa-square-arrow-up-right"></i></a></div>' +
                    '<div class="event-loading">Loading...</div>' +
                    '<div class="event-logs"></div>' +
                '</div>' +
            '</div>';

        this.$el.html(content);

        this.renderConsoleLogs();
        this.renderNetworkLogs();
        this.renderEvents();

        return this;
    }
});